<template>
    <div class="session__show_waitlist">
        <component-button
            :theme="'default'"
            :border="true"
            :animate-loading="true"
            @click="subscribeAction"
            :name="'session-show-waitlist-button'"
        >{{ sessionUserIsSubscribed ? $t('ebs.sessions.show.buttons.leaveWaitlist') : $t('ebs.sessions.show.buttons.joinWaitlist') }}
        </component-button>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: { ComponentButton },
  name: 'session-show-waitlist',
  computed: {
    sessionUserIsSubscribed: function () {
      return this.$store.getters.getSessionUserIsSubscribed
    },
    subscriptionSuccess: function () {
      return this.$store.getters.getSubscriptionSuccess
    }
  },
  methods: {
    subscribeAction: function () {
      if (this.sessionUserIsSubscribed) {
        this.$store.dispatch('unsubscribeOccurrence')
      } else {
        this.$store.dispatch('subscribeOccurrence')
      }
    },
    //
    getSession: function () {
      const sessionID = this.$route.params.sessionId
      this.$store.dispatch('getSession', sessionID)
    }
  },
  watch: {
    subscriptionSuccess: function () {
      if (this.subscriptionSuccess === true) {
        this.$eventBus.$emit('start-loading')
        this.getSession()
        this.$store.dispatch('clearSubscription')
      }
    }
  }
}
</script>
